import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("turbo:before-stream-render", (event) => {
      const { target, action } = event.detail

      if (action === "prepend" && target.id === "enquiries_list") {
        // Fade in animation for new enquiry rows
        const newRow = event.detail.templateElement.content.firstElementChild
        newRow.classList.add("fade-in")
      }
    })
  }
}
